/**
 * PATH: packages/bills/src/components/viewerPrimitives.tsx
 * FILE_ID: BILLS-PKG-CMP-VIEWER-PRIMS-001
 * PURPOSE: Tiny presentational primitives shared across the document viewers.
 *
 * WHY: Extracted from DocumentViewer.tsx to keep that file under the
 *      project's 300-LOC limit while we add new format renderers (docx,
 *      and likely .doc / .xlsx in future). These helpers carry no state
 *      and no side effects, so they're safe to share.
 */

import type { ReactNode } from 'react';

interface ZoomButtonProps {
  onClick: () => void;
  title: string;
  children: ReactNode;
}

export function ZoomButton({ onClick, title, children }: ZoomButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-border bg-background text-base leading-none hover:bg-accent"
    >
      {children}
    </button>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full w-full items-center justify-center bg-muted/30 p-6 text-center text-sm text-muted-foreground">
      <div>{children}</div>
    </div>
  );
}
